import { Component } from '@angular/core';
import { SkeletonBlock } from '../../../../../shared/components/skeleton/skeleton-block';

/** Desktop date-column count (`skelService`). */
const SERVICE_COLUMN_PLACEHOLDER_COUNT = 3;
/** Service cards per desktop date column. */
const SERVICE_CARD_PLACEHOLDER_COUNT = 3;
/** Date-pill placeholders (tablet/mobile). */
const SERVICE_DATE_PILL_PLACEHOLDER_COUNT = 3;
/** Tablet stacked service-card count (768pt prototype). */
const SERVICE_TABLET_CARD_COUNT = 4;
/** Mobile stacked service-card count (390pt prototype). */
const SERVICE_MOBILE_CARD_COUNT = 5;

/**
 * Delivery matrix skeleton.
 * Desktop: three date columns; tablet: pills + four rows; mobile: five cards.
 */
@Component({
  selector: 'app-delivery-service-skeleton',
  imports: [SkeletonBlock],
  templateUrl: './delivery-service-skeleton.html',
  styleUrl: './delivery-service-skeleton.scss',
})
export class DeliveryServiceSkeleton {
  protected readonly columnPlaceholders = Array.from(
    { length: SERVICE_COLUMN_PLACEHOLDER_COUNT },
    (_, index) => index,
  );

  protected readonly cardPlaceholders = Array.from(
    { length: SERVICE_CARD_PLACEHOLDER_COUNT },
    (_, index) => index,
  );

  protected readonly datePillPlaceholders = Array.from(
    { length: SERVICE_DATE_PILL_PLACEHOLDER_COUNT },
    (_, index) => index,
  );

  protected readonly tabletCardPlaceholders = Array.from(
    { length: SERVICE_TABLET_CARD_COUNT },
    (_, index) => index,
  );

  protected readonly mobileCardPlaceholders = Array.from(
    { length: SERVICE_MOBILE_CARD_COUNT },
    (_, index) => index,
  );

  protected readonly mobileFooterLineWidths = ['94%', '86%', '90%', '52%'] as const;
}
